import { render } from "./FrontLayout.vue?vue&type=template&id=0787861b"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"

import "./FrontLayout.vue?vue&type=style&index=0&id=0787861b&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__